import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Matrix4 } from '../math/Matrix4.js';
import { Object3D } from '../core/Object3D.js';

var Camera = /*#__PURE__*/function (_Object3D) {
  _inheritsLoose(Camera, _Object3D);

  function Camera() {
    var _this;

    _this = _Object3D.call(this) || this;
    _this.type = 'Camera';
    _this.matrixWorldInverse = new Matrix4();
    _this.projectionMatrix = new Matrix4();
    _this.projectionMatrixInverse = new Matrix4();
    return _this;
  }

  var _proto = Camera.prototype;

  _proto.copy = function copy(source, recursive) {
    _Object3D.prototype.copy.call(this, source, recursive);

    this.matrixWorldInverse.copy(source.matrixWorldInverse);
    this.projectionMatrix.copy(source.projectionMatrix);
    this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
    return this;
  };

  _proto.getWorldDirection = function getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    var e = this.matrixWorld.elements;
    return target.set(-e[8], -e[9], -e[10]).normalize();
  };

  _proto.updateMatrixWorld = function updateMatrixWorld(force) {
    _Object3D.prototype.updateMatrixWorld.call(this, force);

    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  };

  _proto.updateWorldMatrix = function updateWorldMatrix(updateParents, updateChildren) {
    _Object3D.prototype.updateWorldMatrix.call(this, updateParents, updateChildren);

    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  };

  _proto.clone = function clone() {
    return new this.constructor().copy(this);
  };

  return Camera;
}(Object3D);

Camera.prototype.isCamera = true;
export { Camera };